// src/api/checkout/placeOrderApi.js
import axios from "axios";
import { AFTERPLACEORDERURL } from "../index";

export const afterplaceOrderApi = (postData) => {
  return axios.post(AFTERPLACEORDERURL, postData);
};